module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-36-561999474b3c2fa7edb5840f20e6e6d1.jpg";